// PRE RMA + CSB — Jeu d'icônes SVG (remplace les emojis). Traits arrondis, 24×24, couleur héritée du texte (currentColor).
// Toujours décoratives (aria-hidden) : le libellé texte est affiché à côté, l'icône n'est jamais seule (bonne pratique OMS).
const TRACES: Record<string, string> = {
  home: 'M3 11l9-8 9 8M5 10v10h14V10M10 20v-6h4v6',
  saisie: 'M4 20h4L19 9l-4-4L4 16v4zM13.5 6.5l4 4',
  inv: 'M3 7l9-4 9 4v10l-9 4-9-4V7zM3 7l9 4 9-4M12 11v10',
  rap: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  rma: 'M4 20V4M4 20h16M8 16v-5M12 16V7M16 16v-8',
  cmd: 'M6 3h12v18l-3-2-3 2-3-2-3 2V3zM9 8h6M9 12h6',
  plus: 'M5 12h.01M12 12h.01M19 12h.01',
  cons: 'M6 3v6a4 4 0 008 0V3M10 13v2a5 5 0 0010 0v-2M20 9a2 2 0 100 4 2 2 0 000-4z',
  cpn: 'M12 20s-7-4.5-7-10a4 4 0 017-2.5A4 4 0 0119 10c0 5.5-7 10-7 10z',
  pev: 'M18 3l3 3M16 5l3 3M14 7l3 3-8 8-3 1 1-3 7-9zM3 21l4-4',
  stk: 'M10.5 20.5a4.95 4.95 0 01-7-7l10-10a4.95 4.95 0 017 7l-10 10zM8.5 8.5l7 7',
  fin: 'M5 6h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2zM12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z',
  dec: 'M12 3c3 0 5 2 5 5 0 4-5 7-5 13 0-6-5-9-5-13 0-3 2-5 5-5z',
  com: 'M3 10v4h3l8 4V6L6 10H3zM18 9a4 4 0 010 6',
  ok: 'M5 12l5 5 9-10',
  sync: 'M20 11a8 8 0 00-14-4M4 5v3h3M4 13a8 8 0 0014 4M20 19v-3h-3',
  verrou: 'M6 11h12v9H6zM8 11V8a4 4 0 018 0v3',
  hist: 'M3 12a9 9 0 109-9M3 4v5h5M12 7v5l3 2',
  param: 'M4 7h10M18 7h2M4 17h2M10 17h10M14 4v6M6 14v6',
  abo: 'M3 7h18v10H3zM3 11h18M7 15h3',
  valid: 'M9 12l2 2 4-4M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z',
  admin: 'M12 12a4 4 0 100-8 4 4 0 000 8zM4 21a8 8 0 0116 0',
  ref: 'M5 4h11a3 3 0 013 3v13H8a3 3 0 01-3-3V4zM8 17h11',
  cal: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  hors: 'M3 3l18 18M8.5 8.5A8 8 0 0112 7a8 8 0 016 2.5M5 12a11 11 0 015-3M12 18h.01',
  alerte: 'M12 4l9 16H3L12 4zM12 10v4M12 17h.01',
};

export type NomIcone = keyof typeof TRACES | (string & {});

export default function Icone({ nom, taille = '1.4em', className }: { nom: NomIcone; taille?: string; className?: string }) {
  return (
    <svg className={`icone-svg ${className ?? ''}`} width={taille} height={taille} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={1.9} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d={TRACES[nom] ?? TRACES.ok} />
    </svg>
  );
}
